// One stacking counter for the floating windows of a page (the chat window, the chart windows), as in
// old cortex frontend/src/components/zOrder.js: the window pressed last is on top. One module instance
// per page, whichever host mounts them.
let top = 99999;
export const getTopZ = () => ++top;
